import { render, staticRenderFns } from "./SectionNode.vue?vue&type=template&id=84c5a606&scoped=true"
import script from "./SectionNode.vue?vue&type=script&lang=js"
export * from "./SectionNode.vue?vue&type=script&lang=js"
import style0 from "./SectionNode.vue?vue&type=style&index=0&id=84c5a606&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c5a606",
  null
  
)

export default component.exports